<template src="./Customers.html"/>

<script>
import { computed } from "vue"
import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"
import employee from "../../../Commercial/Employees/Employee/Employee.vue"
import Actions from "./Actions/Actions.vue"

export default {
  components: { Actions, employee },
  mixins: [mixins],
  data() {
    return {
      windowWidth: 0,
      isProjectPlan: false,
      showEmployee: false,
      showCustomersList: true,
      showPopupResendQuiz: false,
      patientResendQuiz: {},
      showWebTable: true,
      showButtonSmallScreen: false,
      patients: [],
      listPatients: true,
      idPatient: 0,
      pageTable: 0,
      imageData: "",
      currentx: 1,
      currentxTotal: 0,
      searchCustomers: "",
      pagination: false,
    };
  },
  watch: {
    currentx () {
      this.getCustomers()
    },
    showCustomersList(val) {
      if (val) {
        this.getCustomers()
      }
    }
  },

  setup () {
    const store = useStore()

    return {
      filooServer: computed(() => store.state.filooServer),
    }
  },

  created () {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  mounted () {
    this.isProjectPlan = this.$session.get("isProject")
      ? this.$session.get("isProject")
      : false
    this.getCustomers()
  },
  destroyed () {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
      this.showWebTable = this.windowWidth >= 1100
      this.showButtonSmallScreen = this.windowWidth < 420
    },
    goToHistoric (idPatient) {
      this.idPatient = idPatient
      this.listPatients = false
    },
    getCustomers () {
      const page = this.currentx - 1
      this.$vs.loading()
      this.axios.get(
        `${this.filooServer}consultant/patients/simplified?page=${page}&search=${this.searchCustomers}&size=10&sort=id,desc&all=false`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ status, data}) => {
          if (status === 200) {
            this.patients = data.content.map((patient) => ({
              ...patient,
              name: patient.name || "Sem registro",
              email: patient.email || "Sem registro",
              phone: patient.phone || "Sem registro",
              status: patient.active || false
            }))

            this.numPages = data.totalPages
            this.pagination = this.numPages > 1
          }
        }).finally(() => {
          this.$vs.loading.close()
        })
    },
    changeSearchCustomers(){
      this.currentx = 1

      this.$vs.loading()
      this.getCustomers()
    },

    clickAddNewCustomer () {
      this.showCustomersList = !this.showCustomersList
      this.showEmployee = !this.showEmployee
    }
  }
};
</script>
<style lang="scss" src="./Customers.scss">
</style>
